import { render, staticRenderFns } from "./AddMediaLabel.vue?vue&type=template&id=e3cb9fca"
import script from "./AddMediaLabel.vue?vue&type=script&lang=js"
export * from "./AddMediaLabel.vue?vue&type=script&lang=js"
import style0 from "./AddMediaLabel.vue?vue&type=style&index=0&id=e3cb9fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports